import moment from "moment";
import { setLoading, unsetLoading } from "../../../store/loading/loading.slice";
import { useCallback, useEffect, useState } from "react";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { IconButton, useMediaQuery, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { NavigateFunction, useNavigate } from "react-router-dom";
import { routeName } from "../../../routes/routeName";
import { AdmissionAdminApi } from "../../../api/admission_admin/admission_admin.api";
import StatusCustom from "../../../components/status/statusCustom";
import { renderStatus } from "../history-online-Admission/enum/admission.enum";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { degreeApi } from "../../../api/degree/degree.api";
import { facultyApi } from "../../../api/factulty/factulty.api";
import { getFileExtension } from "../../../utils/fileTypeDownload";
import saveAs from "file-saver";
import { checkPermission, permission_config } from "../../../utils/app.utils";
import { RootState } from "../../../store/store";
const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const navigate: NavigateFunction = useNavigate();
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const permission: any[] = profile?.permission || [];
    const checkPermit: permission_config = checkPermission("LIST_APPLICANTS", permission)
    const dispatch = useDispatch();
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [status, set_status] = useState<string>("ALL");

    const [data, setData] = useState<any[]>([]);
    const [degree, setDegree] = useState<any[]>([]);
    const [faculty, setFaculty] = useState<any[]>([]);
    const [id_degree, set_id_degree] = useState<any>("ALL");
    const [id_faculty, set_id_faculty] = useState<any>("ALL");

    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);

    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_comment", width: 200, sortable: false, disablePadding: false, align: 'center', label: t("LIST_APPLICANTS_FULL_NAME")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "center", label: t("LIST_APPLICANTS_NICKNAME")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("LIST_APPLICANTS_LEVEL")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("LIST_APPLICANTS_FACULTY")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("LIST_APPLICANTS_APPLICATION_DATE")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("LIST_APPLICANTS_PAYMENT")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 181, label: t("LIST_APPLICANTS_STATUS")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            middle_name,
            faculty_name,
            created_date,
            modified_date,
            degree_name,
            id_admission_student,
            first_name,
            last_name,
            student_register_payment_status,
            admission_status
        } = objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: `${first_name} ${last_name}` || "-" },
                {
                    option: "TEXT",
                    align: "center",
                    label: middle_name || "-",
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: degree_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: faculty_name || "-",
                },

                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? moment(modified_date).add(543, 'year').format("DD/MM/YYYY") : created_date ? moment(created_date).add(543, 'year').format("DD/MM/YYYY") : "-"
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: student_register_payment_status === 'PAID' ? <CheckBoxOutlinedIcon sx={{ color: "#0F9F0C" }} /> : <CheckBoxOutlinedIcon sx={{ color: "#e7e7e7" }} />,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: <StatusCustom
                        disableMaxWidth
                        text={renderStatus(admission_status)}
                        type={renderStatus(admission_status)}
                    />,
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        {checkPermit.isView && <IconButton onClick={() => navigate(routeName.admission.applicants_detail.replace(':id', id_admission_student))}>
                            <ArrowForwardIosIcon />
                        </IconButton>}
                        {/* <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => handleGetOneDetail(id_comment, 'VIEW')}
                            onEditClick={() => handleGetOneDetail(id_comment, 'EDIT')}
                            onDeleteClick={() => handleDeleteList(id_comment)}
                        /> */}
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit,
            sortType: sortType,
            sortBy: sortBy
        }
        if (keyword) query = { ...query, search: keyword }
        if (status) query = { ...query, admission_status: status }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
        dispatch(setLoading());
        await AdmissionAdminApi.list(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate, id_degree, id_faculty])



    useEffect(() => {
        handleGetData()
    }, [handleGetData])

    const getDegree = async () => {
        await degreeApi.getDegree().then((res) => {
            if (res.status < 300) {
                setDegree(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getFaculty = async () => {
        await facultyApi.getFaculty().then((res) => {
            if (res.status < 300) {
                setFaculty(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        getDegree()
        getFaculty()
    }, [])
    const handleDownloadFile = async () => {
        let query: any = {
            page: page,
            limit: pageLimit,
            sortType: sortType,
            sortBy: sortBy
        }
        if (keyword) query = { ...query, search: keyword }
        if (status) query = { ...query, admission_status: status }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        if (id_degree !== 'ALL') query = { ...query, id_degree: id_degree }
        if (id_faculty !== "ALL") query = { ...query, id_faculty: id_faculty }
        dispatch(setLoading());

        await AdmissionAdminApi.report_admission_students(query)
            .then((res) => {
                if (res.status < 300) {
                    const response = res.data;

                    // Get the content type from the server's response headers
                    const contentType = res.headers["content-type"];

                    // Create a Blob with the content type from the response
                    const blob = new Blob([response], { type: contentType });

                    // Extract file extension based on content type
                    const fileExtension = getFileExtension(contentType || "");

                    // Generate a filename with the correct extension (you can also modify this to use a custom name)
                    const fileName = `${"report-advisor" + new Date().getTime()
                        }.${fileExtension}`;

                    // Save the file
                    saveAs(blob, fileName);
                }
            })
            .catch((error) => console.log(error))
            .finally(() => dispatch(unsetLoading()));
    };
    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        degree,
        faculty,
        id_degree,
        set_id_degree,
        id_faculty,
        set_id_faculty,
        status,
        set_status,
        handleDownloadFile,
        checkPermit
    }
}

export default ManageState